import { axios } from '@/plugins/axios';

export function getCategoriesLieuVaccination() {
	return axios.get('/vaccination-covid-api/locations');
}
